export type SeasonalMonth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

// Helper to get current month (returns 1-12)
export const getCurrentMonth = (): SeasonalMonth => {
  return (new Date().getMonth() + 1) as SeasonalMonth;
};

// Helper to convert month selection to sort parameter for URL
// Always uses 'month_X' format for consistency in URL
export const monthToSortParam = (month: SeasonalMonth): string => {
  return `month_${month}`;
};

// Helper to convert month selection to API parameter
// Current month uses 'seasonal', all other months use 'month_X'
export const monthToApiParam = (month: SeasonalMonth): string => {
  const currentMonth = getCurrentMonth();

  // If it's the current month, use 'seasonal'
  // "seasonal" sort is more of a live/trending sort that returns more dynamic results
  if (month === currentMonth) {
    return 'seasonal';
  }

  return `month_${month}`;
};

// Helper to convert API parameter back to month selection
export const sortParamToMonth = (sortParam: string): SeasonalMonth => {
  // If it's 'seasonal', return current month
  if (sortParam === 'seasonal') {
    return getCurrentMonth();
  }

  // Extract month number from 'month_X' format
  const match = sortParam.match(/^month_(\d+)$/);
  if (match) {
    const monthNum = parseInt(match[1], 10);
    if (monthNum >= 1 && monthNum <= 12) {
      return monthNum as SeasonalMonth;
    }
  }

  // Fallback to current month if invalid
  return getCurrentMonth();
};
